import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { projectsApi } from 'src/Services/API';
import { editProjectCommentsCache } from 'src/Services/API/cache';
import { CreateCommentDto, CommentDto } from 'src/Services/API/generated';

export type EditProjectCommentVariables = {
  projectId: string;
  assetId: string;
  commentId: string;
} & CreateCommentDto;

export const useEditProjectComment = (
  options?: UseMutationOptions<CommentDto, unknown, EditProjectCommentVariables>
) => {
  const queryClient = useQueryClient();

  return useMutation<CommentDto, unknown, EditProjectCommentVariables>(
    'edit-project-comment',
    async (variables: EditProjectCommentVariables) => {
      const response = await projectsApi.projectsControllerEditComment(
        variables.projectId,
        variables.commentId,
        variables.assetId,
        variables
      );

      return response.data;
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        // Edit the comment from comments list query
        editProjectCommentsCache(queryClient, variables.projectId, original =>
          original.id === variables.commentId ? data : original
        );

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
